import { Box, Button, Color, DisplayPosition, withCitrusTheme } from '@gousto-internal/citrus-react'

export const Card = withCitrusTheme(Box, () => ({
  width: '100%',
  height: '100%',
  borderRadius: '4px',
  boxShadow: '0 1px 5px 0 rgba(51, 61, 71, 0.2)',
  color: '#333D47',
  cursor: 'pointer',
  position: DisplayPosition.Relative,
  textRendering: 'optimizeLegibility',
  '&:hover': {
    boxShadow: '0 4px 14px 0 rgba(51, 61, 71, 0.2)',
  },
}))

export const RecipeDetailsOverlayButton = withCitrusTheme('button', () => ({
  appearance: 'none',
  background: 'transparent',
  border: 0,
  padding: 0,
  margin: 0,
  position: DisplayPosition.Absolute,
  inset: 0,
  borderRadius: '4px',
  cursor: 'pointer',
  zIndex: 20,
  '&:focus-visible': {
    outline: '2px solid #615CFF',
    outlineOffset: '2px',
  },
}))

export const ImageContainer = withCitrusTheme(Box, () => ({
  minHeight: '200px',
  maxHeight: '270px',
  borderRadius: '4px 4px 0 0',
  position: DisplayPosition.Relative,
  overflow: 'hidden',
  [`@media (min-width: 768px)`]: {
    height: '270px',
  },
}))

export const DietaryBadge = withCitrusTheme(Box, (theme) => ({
  width: '28px',
  height: '28px',
  borderRadius: '999px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.tokens.colors.ColdGrey_700,
  color: theme.tokens.colors.White,
}))

export const LabelPill = withCitrusTheme(Box, () => ({
  borderRadius: '4px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '24px',
  minWidth: 0,
  maxWidth: '100%',
  padding: '0 0.5rem',
}))

export const FloatingButtonContainer = withCitrusTheme(Box, () => ({
  position: DisplayPosition.Absolute,
  top: '1rem',
  right: '1rem',
  transform: 'translateY(calc(-50% - 1rem))',
  width: '48px',
  height: '48px',
  borderRadius: '6px',
  backgroundColor: '#FFFFFF',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 30,
}))

export const ActionButton = withCitrusTheme(Button, (theme) => ({
  '&:disabled, &:disabled:hover, &:disabled:focus': {
    color: theme.color(Color.White),
  },
}))

export const Banner = withCitrusTheme(Box, () => ({
  containerType: 'inline-size',
  padding: '0.25rem 0.75rem',
}))
